import '../asset/main.css'
import imagecover from '../asset/images/15.png'
import AddIcon from 'remixicon-react/AddCircleLineIcon'
import Close from 'remixicon-react/CloseLineIcon'
import Upload from 'remixicon-react/UploadCloudFillIcon'
import Bin from 'remixicon-react/DeleteBinLineIcon'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useState } from 'react'

import { useSpring, animated } from 'react-spring';


import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { useEffect, useRef } from 'react';

import { getAllLanguage, getAllDatabase, getAllPosition, addProject } from '../firebase'

import { ref, uploadBytes, getDownloadURL, uploadBytesResumable } from 'firebase/storage';

import { app, storage } from '../firebase'

const initialData = [
    {
        name: "Duy Thanh",
        position: "Dev"
    },
    // {
    //     name: "Nguyen Duy",
    //     position: "Designer"
    // },
    // {
    //     name: "Wang",
    //     position: "Back-end"
    // },
    // {
    //     name: "Huynh Tuan",
    //     position: "Front-end"
    // },
    // {
    //     name: "Duck Vinh",
    //     position: "Tester"
    // },
    // {
    //     name: "Th4i",
    //     position: "DevObs"
    // },
    // {
    //     name: "Trong Tai",
    //     position: "Security"
    // },
    // {
    //     name: "Phat",
    //     position: "BA"
    // }
]

const initialDataLG = [
    {
        nameLang: "JavaScript",

    }
]

const initialDataDB = [
    {
        nameDB: "Mongo",

    },


]



export default function AddProject({ onHideBox }) {

    const handleHideBox = () => {
        onHideBox();
    };

    const [allLanguage, setAllLanguage] = useState();
    const [allDatabase, setAllDatabase] = useState();
    const [allPosition, setAllPosition] = useState();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const LangData = await getAllLanguage();

                setAllLanguage(LangData)

                const listDB = await getAllDatabase();

                setAllDatabase(listDB);

                const listPosition = await getAllPosition();

                setAllPosition(listPosition)

                console.log(allLanguage)
                console.log(allDatabase)

            } catch (error) {
                console.error('Error fetching about data:', error);
            }
        };
        fetchData();
    }, []);
    const [dataCollab, setDataColab] = useState(initialData)
    const [dataLanguage, setDataLanguage] = useState(initialDataLG)
    const [dataDB, setDataDB] = useState(initialDataDB)
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [nameCollab, setNameCollab] = useState('');
    const [namePosition, setNamePosition] = useState('');
    const [nameLanguage, setNameLanguage] = useState('');
    const [nameDB, setNameDB] = useState('');
    const [linkReview, setLinkReview] = useState('')
    const [progress, setProgress] = useState(0);
    // show box language
    const [showBoxAddLanguage, setShowBoxAddLanguage] = useState(false)

    const ToggleBoxAddLanguage = () => {
        setShowBoxAddLanguage(!showBoxAddLanguage)
    }
    const springProps = useSpring({
        opacity: showBoxAddLanguage ? 1 : 0,
        transform: showBoxAddLanguage ? 'translateX(0)' : 'translateX(-100%)',
    });
    // get all data to a object 
    const [totalData, setTotalData] = useState({})
    const submitProject = () => {
        addProject(totalData)
            .then((e) => {
                alert("Successfully!")
            })
            .catch((error) => {
                console.log("ERROR: " + error)
            })
    }
    useEffect(() => {
        const formatOptions = { year: 'numeric', month: 'numeric', day: 'numeric' };

        const formattedStartDate = startDate.toLocaleDateString('en-US', formatOptions);
        const formattedEndDate = endDate.toLocaleDateString('en-US', formatOptions);

        setTotalData({
            ...totalData,
            startDate: formattedStartDate,
            endDate: formattedEndDate,
        })
    }, [startDate, endDate])
    const tbodyRef = useRef(null);
    const addCollab = () => {
        const dataCollection = [
            ...dataCollab,
            {
                name: nameCollab ? nameCollab : '',
                position: namePosition ? namePosition : ''
            }
        ]
        if (nameCollab === '') {
            alert('Bạn chưa nhập tên Collaborator')
        }
        else if (namePosition === '') {
            alert('Bạn chưa chọn vị trí')
        }
        else {
            setDataColab(dataCollection)
        }
        console.log(dataCollab)
    }
    const handleDelete = (index) => {
        const newDataCollab = dataCollab.filter((_, i) => i !== index);
        setDataColab(newDataCollab);
    };
    const addLanguage = () => {
        const dataCollection = [
            ...dataLanguage,
            {
                nameLang: nameLanguage ? nameLanguage : '',
            }
        ]

        if (nameLanguage === '') {
            alert('Chưa chọn ngôn ngữ')
        }
        else {
            setDataLanguage(dataCollection)
        }
        console.log(dataLanguage)
    }
    useEffect(() => {
        setTotalData({
            ...totalData,
            listLang: dataLanguage,
            listData: dataDB,
            listCollab: dataCollab
        })
    }, [dataLanguage, dataDB, dataCollab])
    const handleDeleteLang = (index) => {
        const newDataCollab = dataLanguage.filter((_, i) => i !== index);
        setDataLanguage(newDataCollab);
    };
    const addDB = () => {
        const dataCollection = [
            ...dataDB,
            {
                nameDB: nameDB ? nameDB : '',
            }
        ]

        if (nameDB === '') {
            alert('Chưa chọn tên database')
        }
        else {
            setDataDB(dataCollection)
        }
        console.log(dataLanguage)
    }
    const handleDeleteDB = (index) => {
        const newDataCollab = dataDB.filter((_, i) => i !== index);
        setDataDB(newDataCollab);
    };
    const Popup = ({ message, onConfirm, onCancel }) => {
        return (
            <div className="popup">
                <p>{message}</p>
                <div className="wrap-butun-popup" style={{
                    display: 'flex',
                    gap: 20
                }}>
                    <button onClick={onConfirm}>Đồng ý</button>
                    <button style={{ backgroundColor: 'rgb(241, 78, 106)', color: '#fff' }} onClick={onCancel}>Hủy</button>
                </div>
            </div>
        );
    };
    const [showPopup, setShowPopup] = useState(false);
    const handleConfirm = () => {
        console.log('Đã đồng ý');
        submitProject()
        setShowPopup(false);
    };
    const handleCancel = () => {
        console.log('Đã hủy bỏ');
        setShowPopup(false);
    };
    const handleOpenPopup = () => {
        setShowPopup(true);
    };
    const [imgData, setImageData] = useState();
    const [avatar, setAvatar] = useState()
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setAvatar(file)
        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                const dataURL = reader.result;
                setImageData(dataURL);

                console.log(imgData)
            };
            reader.readAsDataURL(file);
        }
    };
    const uploadImage = () => {
        if (avatar) {
            const storageRef = ref(storage, `avartar/${avatar.name}`);
            const uploadTask = uploadBytesResumable(storageRef, avatar);

            uploadTask.on(
                'state_changed',
                (snapshot) => {
                    const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    console.log('Upload is ' + progress + '% done');
                    setProgress(progress);
                },
                (error) => {
                    console.error(error);
                },
                () => {
                    getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                        console.log('File available at', downloadURL);
                        setTotalData({
                            ...totalData,
                            avatarProject: downloadURL
                        })

                    });
                }
            );
        } else {
            console.log('No image selected');
        }
    };
    return (
        <div className="addproject">
            <div className="button-close">
                <div className="wrap-button_close" onClick={handleHideBox}>
                    <Close size={40} color='#585858'></Close>
                </div>
            </div>
            <div className="wrap-addproject">
                <div className="addproject-left">
                    <div className="wrap-addproject-left">
                        <div className="addproject-left_name">
                            <h2>Name project</h2>
                            <input type="text" onChange={(name) => {
                                setTotalData({
                                    ...totalData,
                                    nameProject: name.target.value
                                })
                            }} />
                        </div>
                        <div className="addproject-left_description">
                            <h2>Description project</h2>
                            <textarea onChange={(desc) => {
                                setTotalData({
                                    ...totalData,
                                    description: desc.target.value
                                })
                            }}></textarea>
                        </div>
                        <div className="addproject-left_uploadimg">
                            <div className="option-image_buttonup" onClick={uploadImage}>
                                <Upload color='#585858' size={34} ></Upload>
                            </div>
                            <div className="wrap-previewimage">
                                <h2>Image cover</h2>
                                <div className="wrap-previewimage_picture">
                                    <img src={imgData ? imgData : imagecover} alt="Preview" />
                                </div>
                                <div className="wrap-button-addfile">
                                    <input type="file"
                                        onChange={handleFileChange} />

                                    <div className="progress-bar" style={{ width: `${progress}%` }}>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="addproject-left_option2">
                            <h2>Language</h2>
                            <div className="wrap-button-addproject" >
                                <input type="button" value={showBoxAddLanguage ? 'Hide box' : 'Open box'} onClick={ToggleBoxAddLanguage} />
                            </div>
                        </div>
                        <div className="addproject-left_wrapdate">
                            <div className="wrapdate-start">
                                <h2>Date start</h2>
                                <DatePicker selected={startDate} onChange={(date) => setStartDate(date)} />
                            </div>

                            <div className="wrapdate-end">
                                <h2>Date end</h2>
                                <DatePicker selected={endDate} onChange={(date) => setEndDate(date)} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="space-addproject">

                    {showBoxAddLanguage ? (
                        <animated.div style={springProps}>


                            <div className="adlagugage">
                                <div className="wrap-brief-desc-project">
                                    <h2>Brief title</h2>
                                    <input type="text" onChange={(value) => {
                                        setTotalData({
                                            ...totalData,
                                            briefDes: value.target.value
                                        })
                                    }} />
                                </div>
                                <div className="addproject-left_option">
                                    <div className="option-language">
                                        <h2>Language</h2>

                                        <div className="wrap-optiondatabase">
                                            <select value={nameLanguage} onChange={(value) => {
                                                setNameLanguage(value.target.value)
                                            }}>
                                                {
                                                    allLanguage ? (
                                                        allLanguage.map((data, index) => (
                                                            <option key={index} value={data.NameLang}>{data.NameLang}</option>
                                                        ))
                                                    ) : (<option >Đang Load....</option>)
                                                }

                                            </select>
                                            <div className="option-position_buttonadd-db" onClick={addLanguage}>
                                                <AddIcon size={40} color='#585858'></AddIcon>
                                            </div>
                                        </div>


                                        <div className="addproject-right_resultadd-wrap">
                                            <div className="table-container-source">
                                                <table width="100%" border="1" cellPadding="5">
                                                    <thead>
                                                        <tr>
                                                            <th>Language</th>
                                                            <th>Delete</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody ref={tbodyRef}>
                                                        {dataLanguage.map((data, index) => (
                                                            <tr key={index} className='row-of-collab'>
                                                                <td>{data.nameLang}</td>
                                                                <td className='button-bin' onClick={() => { handleDeleteLang(index) }}><Bin></Bin></td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="option-database">
                                        <h2>Datebase</h2>
                                        <div className="wrap-optiondatabase">
                                            <select value={nameDB} onChange={(value) => {
                                                setNameDB(value.target.value)
                                            }}>
                                                {
                                                    allDatabase ? (
                                                        allDatabase.map((data, index) => (
                                                            <option key={index} value={data.NameDB}>{data.NameDB}</option>
                                                        ))
                                                    ) : (<option >Đang Load....</option>)
                                                }

                                            </select>
                                            <div className="option-position_buttonadd-db" onClick={addDB}>
                                                <AddIcon size={40} color='#585858'></AddIcon>
                                            </div>


                                        </div>
                                        <div className="addproject-right_resultadd-wrap">
                                            <div className="table-container-source">
                                                <table width="100%" border="1" cellpadding="5">
                                                    <thead>
                                                        <tr>
                                                            <th>Database</th>
                                                            <th>Delete</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody ref={tbodyRef}>
                                                        {dataDB.map((data, index) => (
                                                            <tr key={index} className='row-of-collab'>
                                                                <td>{data.nameDB}</td>
                                                                <td className='button-bin' onClick={() => { handleDeleteDB(index) }}><Bin></Bin></td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </animated.div>) : (<></>)}
                </div>

                <div className="addproject-right">
                    <div className="wrap-addproject-right">

                        <div className="addproject-right_collaborator">
                            <h2>Link review</h2>
                            <input type="text" onChange={(text) => {
                                setTotalData({
                                    ...totalData,
                                    linkreview: text.target.value
                                })
                            }} />
                        </div>

                        <div className="addproject-right_collaborator">
                            <h2>Collaborator name</h2>
                            <input type="text" onChange={(text) => {
                                setNameCollab(text.target.value)
                            }} />
                        </div>

                        <div className="addproject-right_position">
                            <div className="option-position">
                                <div className="wrap_header-position">
                                    <h2>Position</h2>
                                    <div className="option-position_buttonadd" onClick={addCollab}>
                                        <AddIcon size={40} color='#585858'></AddIcon>
                                    </div>
                                </div>
                                <select value={namePosition} onChange={(value) => {
                                    setNamePosition(value.target.value)
                                }}>
                                    {
                                        allPosition ? (
                                            allPosition.map((data, index) => (
                                                <option key={index} value={data.NamePosition}>{data.NamePosition}</option>
                                            ))
                                        ) : (<option >Đang Load....</option>)
                                    }

                                </select>
                            </div>

                        </div>
                    </div>

                    <div className="addproject-right_resultadd">
                        <div className="addproject-right_resultadd-wrap">
                            <div className="table-container-collab">
                                <table width="100%" border="1" cellpadding="5">
                                    <thead>
                                        <tr>
                                            <th>Collaborator name</th>
                                            <th>Position</th>
                                            <th>Delete</th>
                                        </tr>
                                    </thead>
                                    <tbody ref={tbodyRef}>
                                        {dataCollab.map((data, index) => (
                                            <tr key={index} className='row-of-collab'>
                                                <td>{data.name}</td>
                                                <td>{data.position}</td>
                                                <td className='button-bin' onClick={() => { handleDelete(index) }}><Bin></Bin></td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div className="wrap-button-addproject" onClick={handleOpenPopup} >
                        <input type="button" value="Add" />
                    </div>
                    {showPopup && (
                        <Popup
                            message="Bạn có chắc chắn muốn thực hiện hành động này?"
                            onConfirm={handleConfirm}
                            onCancel={handleCancel}
                        />
                    )}
                </div>
            </div>
        </div>

    )
}